import type { SessionManager } from '@/lib/SessionTracking/SessionManager';
import {
  STUDENT_REPORT_LOGIN_FEATURE_ID,
  StudentReportLoginEventName,
} from '@/utility/studentReportLoginTracking';

export const recordStudentReportLoginEvent = (
  sessionManager: SessionManager | null | undefined,
  eventName: StudentReportLoginEventName,
  metadata?: Record<string, unknown>
) => {
  if (!sessionManager) {
    return;
  }

  sessionManager.recordUserAction(eventName, {
    action_detail: 'Room Code Log-in',
    action_id: eventName,
    feature: STUDENT_REPORT_LOGIN_FEATURE_ID,
    ...metadata,
  });
};
